// React
import React, { useState, useEffect, useRef } from "react";

// React Async
import Async from "react-async";

// Components
import { Button, Form, Tabs, Tab, InputGroup, FormControl } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import PersonIndexItem from "../components/PersonIndexItem.js";

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";

// AWS
import { Auth, API } from "aws-amplify";

// UUID
const uuidv4 = require('uuid/v4');

export default function PeopleSideBar(props) {
  const [personList, setPersonList] = useState([]);
  const [filteredPersonList, setFilteredPersonList] = useState([]);
  const [reloadProtocol, setReloadProtocol] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [focus, setFocus] = useState(false);

  const searchQueryInputRef = React.useRef();

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    fetchAllPeople();
  }

  function fetchAllPeople() {
    if (props.email === null) {
      return;
    }
    EventifyAPI.getAllPeople().then( (persons) => {
      setPersonList(persons);
      setFilteredPersonList(persons);
      setReloadProtocol(uuidv4());
    });
  }

  function renderPersonList(persons) {
    return (
      <>
        {persons.map( (person, i) => (
          <li key={person.personid}>
            <PersonIndexItem
              key={`personindexitem_${person.personid}`}
              email={props.email}
              organizationid={props.organizationid}
              person={person}
            />
          </li>
        ))}
      </>
    );
  }

  var currentSearchQueryLocal = "";

  function searchQueryChanged(query) {
    if (searchQueryInputRef.current === null) {
      return;
    }

    currentSearchQueryLocal = searchQueryInputRef.current.value.trim();
    if (currentSearchQueryLocal === "") {
      setFilteredPersonList(personList);
      setReloadProtocol(uuidv4());
      return;
    }

    setTimeout( function() {
      const lowerCaseQuery = currentSearchQueryLocal.toLowerCase();
      var newList = [];
      for (var k=0; k<personList.length; k++) {
        const person = personList[k];
        const name = person.name !== null ? person.name : "";
        const email = person.email !== null ? person.email : "";
        if (name.toLowerCase().indexOf(lowerCaseQuery) !== -1 || email.toLowerCase().indexOf(lowerCaseQuery) !== -1) {
          newList.push(person);
        }
      }
      setFilteredPersonList(newList);
      setReloadProtocol(uuidv4());
    }, 0 );
  }

  function focused() {
    setFocus(true);
  }

  function notFocused() {
    setFocus(false);
  }

  return (
    <div className="people-side-bar">
      <label className="toggle-btn">click me</label>
      <input id="sidebar-toggle" type="checkbox" />

      <div className="content">
        <button
          type="button"
          className="btn btn-primary create-list-button"
          onClick={props.createNewPersonAction}
        >
          Create Person
        </button>
        <InputGroup className="mb-3">
          <InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1">Search</InputGroup.Text>
          </InputGroup.Prepend>
          <Form.Control ref={searchQueryInputRef} placeholder="Name or Email" onFocus={focused} onBlur={notFocused} onChange={searchQueryChanged} />
        </InputGroup>
        <ul className="list-index">
          {renderPersonList(filteredPersonList)}
        </ul>
      </div>
    </div>
  );
}
